const router = {
  path: 'setting',
  name: 'setting',
  component: resolve => require(['../../views/setting/index.vue'], resolve),
  meta: {
    requireAuth: true,
    keepAlive: false,
    title: '系统设置',
    level: 1
  },
  children: [
    {
      path: 'company',
      name: 'company',
      meta: {
        requireAuth: true,
        title: '企业设置',
        level: 2,
        keepAlive: false,
      },
      component: resolve => require(['../../views/setting/company/index.vue'], resolve)
    },
    {
      path: 'user',
      name: 'user',
      meta: {
        requireAuth: true,
        title: '个人设置',
        level: 2,
        keepAlive: false,
      },
      component: resolve => require(['../../views/setting/user/index.vue'], resolve)
    },
    {
      path: 'customer',
      name: 'customer',
      meta: {
        requireAuth: true,
        title: '员工设置',
        level: 2,
        keepAlive: false,
      },
      component: resolve => require(['../../views/setting/customer/index.vue'], resolve)
    },
  ]
}

export default router



// WEBPACK FOOTER //
// ./src/router/module/setting.js